module.exports = __webpack_public_path__ + "media/images/ballet-0f92c6b55a98b081db7548a616982d3b.svg";